import {createFileRoute} from '@tanstack/react-router';

import {severityScaleKeys} from '@/features/Library/api/queryKeys';
import {getSeverityScale} from '@/features/Library/api/readSeverityScale';
import {SeverityScaleModal} from '@/features/Library/components/Severity/SeverityScaleModal';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute('/_b/_p/_library/severities/$severityId')({
  component: SeverityScaleModal,

  beforeLoad: ({params, context}) => {
    makeDocumentTitle(params.severityId);

    return {
      ...context,
      readSeverityQuery: {
        queryKey: severityScaleKeys.detail(params.severityId),
        queryFn: () => getSeverityScale(params.severityId),
      },
    };
  },

  loader({context}) {
    return context.queryClient.ensureQueryData(context.readSeverityQuery);
  },
});
